import { MapTo } from '@adobe/aem-react-editable-components';
import FloatingCta, { FloatingCtaEditConfig } from './FloatingCta';

export default MapTo('cob-corp-acquisition/components/creditonebank/floating-cta')(FloatingCta, FloatingCtaEditConfig);